import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const PopularTravelPostsContainer = styled.div`
  margin: 32px 0px;
`

export const PopularTravelPostsHeadContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopularTravelPostsHeading = styled.div`
  color: #131717;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  ${down('md')} {
    font-size: 20px;
  }
`

export const SeeAllPopularTravelPosts = styled.a<{ isTablet?: boolean }>`
  display: flex;
  padding: 7px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid#D7DDDB;
  background: #fff;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  height: 32px;
  transition: 0.3s all;
  &:hover {
    background-color: rgb(248, 250, 249);
    border-color: rgb(189, 197, 193);
  }
  ${down('md')} {
    font-size: 16px;
    margin-top: 16px;
    height: 50px;
  }

  ${({ isTablet }) =>
    isTablet &&
    `
    margin-top: 16px;
    height: 44px;
  `}
`
export const PopularTravelPostsHeadWrapper = styled.div<{ isRTL: boolean; isMobile: boolean }>`
  margin-left: 0px;
  margin-top: 24px;
  ${({ isRTL, isMobile }) => (isMobile ? (isRTL ? `margin-left: calc(50% - 50vw);` : `margin-right: calc(50% - 50vw);`) : '')}
  ul > div:not(:first-child) {
    ${down('md')} {
      /* margin-left: 16px; */
    }
  }
  ul > div {
    width: ${1120 / 3}px;
  }
  ${down('md')} {
    margin-top: 16px;
  }
`
